import { getRelevanceTextColor } from "../../../utils/opportunityCard";

export default function RelevanceScoreBadge({ score, className = "", align = "right" }) {
    if (score == null) return null;

    return (
        <div
            className={`shrink-0 leading-none ${align === "left" ? "text-left" : "text-right"} ${className}`.trim()}
            title={`${score}% relevant`}
        >
            <p className={`mb-0 text-xl font-bold tabular-nums ${getRelevanceTextColor(score)}`}>
                {score}%
            </p>
            <p className="mb-0 mt-1 text-[10px] font-medium uppercase tracking-[0.12em] text-slate-400">
                relevance
            </p>
        </div>
    );
}
